<template>
  <div>
    <vue-headful :title="this.setPageTitle('search')" />
    <grand-summary></grand-summary>

    <b-container>
      <div>
        <b-row>
          <b-col cols="12" class="filter-row">
            <!-- Left: Filtri toggle -->
            <button
              class="filters-trigger-btn"
              :class="{ active: sidebarOpen }"
              @click="setSidebarOpen(!sidebarOpen)"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="4" y1="6" x2="20" y2="6" />
                <line x1="8" y1="12" x2="16" y2="12" />
                <line x1="11" y1="18" x2="13" y2="18" />
              </svg>
              {{ $t('common.filters') }}
              <span v-if="countFiltersSelected > 0" class="filters-trigger-badge">{{ countFiltersSelected }}</span>
            </button>
            <div class="ml-auto">
              <div id="optTabChart" class="pointer w-auto float-right tabs-group">
                <button class="tab-btn" :class="{ active: currentView === 'tab' }" @click="setCurrentView('tab')">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                    <line x1="4" y1="6" x2="20" y2="6" />
                    <line x1="4" y1="12" x2="20" y2="12" />
                    <line x1="4" y1="18" x2="20" y2="18" />
                  </svg>
                  {{ $t('common.products') }}
                </button>
                <button class="tab-btn" :class="{ active: currentView === 'chart' }" @click="setCurrentView('chart')">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="20" x2="18" y2="10" />
                    <line x1="12" y1="20" x2="12" y2="4" />
                    <line x1="6" y1="20" x2="6" y2="14" />
                    <line x1="2" y1="20" x2="22" y2="20" />
                  </svg>
                  {{ $t('common.statistics') }}
                </button>
                <button
                  v-if="canViewSemanticSearch"
                  class="tab-btn tab-btn-documenti"
                  :class="{ active: currentView === 'pigro' }"
                  @click="setCurrentView('pigro')"
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                  </svg>
                  {{ $t('common.documents') }}
                </button>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <active-filters :n-of-products-filtered="paginator.totalItems"></active-filters>
          </b-col>
        </b-row>

        <div class="content-with-sidebar">
          <!-- ══ FILTERS SIDEBAR ══ -->
          <transition name="fsb-slide">
            <div v-show="sidebarOpen">
              <filters-panel v-if="!catalogLoading"></filters-panel>
              <custom-spinner v-else></custom-spinner>
            </div>
          </transition>

          <div class="content-main">
            <div
              class="main-card"
              v-if="!isSearching && (isSearchResultsFound || isChartsResultsFound || isPigroResultsFound)"
            >
              <template v-if="currentView === 'tab'">
                <b-row>
                  <b-col cols="12">
                    <!-- No static `active` on the first b-tab: it's controlled entirely by :value —
                         a static `active` on a child wins on every (re)mount, e.g. whenever the
                         v-if above remounts this block after a search (any sort change included),
                         snapping the visible tab back to "General" regardless of :value. -->
                    <b-tabs class="fairmat-primary-tabs" content-class="mt-3" :value="selectedTableTab" @input="setSelectedTableTab">
                      <b-tab v-for="tab in resultTabs" :key="tab">
                        <template v-slot:title>{{ resultTabLabel(tab) }}</template>
                      </b-tab>
                    </b-tabs>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="results-container">
                    <results-table
                      class="p-2"
                      :paginator="paginator"
                      :search-result="searchResult"
                      :shown-fields="shownFields"
                      :sorting-changed="sortingChanged"
                      :is-downloading="isDownloading"
                      :infinite="true"
                      :is-loading-more="isLoadingMore"
                      :searching="isSearching"
                      @on-change-page-size="onChangePageSize"
                      @on-change-page-index="onChangePageIndex"
                      @export-requested="exportData"
                      @load-more="loadMore"
                    />
                  </b-col>
                </b-row>
              </template>

              <template v-if="currentView === 'chart'">
                <b-row>
                  <b-col cols="12">
                    <loading :active="isSearching" :is-full-page="false" :color="loaderColor" loader="spinner" />
                    <b-tabs class="fairmat-primary-tabs" content-class="mt-3 mb-3" v-model="chartTabIndex" lazy>
                      <b-tab>
                        <template v-slot:title>
                          {{ $t('common.riyGrossReturn') }}
                          <custom-tooltip
                            :css-class="['pointer']"
                            :section="'riyGrossReturn'"
                            :tooltipText="$t('search.tips.chartRiyGrossReturn')"
                            :variant="'black'"
                          ></custom-tooltip>
                        </template>
                        <b-container>
                          <b-form-row>
                            <b-col cols="4" class="font-weight-bold">{{ $t('search.label.confidenceLevel') }}</b-col>
                            <b-col v-if="!isInvestmentCertificates" cols="4" class="font-weight-bold">{{ $t('search.label.ifMop') }}</b-col>
                          </b-form-row>
                          <b-form-row class="mb-3">
                            <b-col cols="4">
                              <b-select :options="confidenceLevelOptions" v-model="confidenceLevel" size="sm"></b-select>
                            </b-col>
                            <b-col v-if="!isInvestmentCertificates" cols="4">
                              <b-select
                                :options="returnRiskCostLabels.ifMopShowOptions"
                                v-model="whenMopVisualizeRiyGrossReturn"
                                size="sm"
                              ></b-select>
                            </b-col>
                          </b-form-row>
                          <riy-gross-return-chart
                            v-if="!isSearching && isRiyGrossChartResultsFound"
                            :animation="false"
                            :key="riyGrossReturnKey"
                            :title="$t('common.riyGrossReturn')"
                            v-model="chartsData.riyGrossReturn"
                            v-on:column-click="showRiyGrossReturnDistributionData"
                          />
                          <no-content
                            v-else-if="!isSearching && chartsLoaded.riyGrossReturn"
                            :icon-name="'exclamation-circle'"
                            :icon-class="['mb-3', 'fa-3x']"
                            :text="$t('common.noChartDataFound')"
                          ></no-content>
                        </b-container>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          {{ $t('common.returnRiskCost') }}
                          <custom-tooltip
                            :css-class="['pointer']"
                            :section="'returnRiskCost'"
                            :tooltipText="$t('search.tips.chartReturnRiskCost')"
                            :variant="'black'"
                          ></custom-tooltip>
                        </template>
                        <b-container>
                          <b-form-row>
                            <b-col cols="4" class="font-weight-bold">{{ $t('marketComparation.x') }}</b-col>
                            <b-col cols="4" class="font-weight-bold">{{ $t('marketComparation.y') }}</b-col>
                            <b-col cols="4" class="font-weight-bold">{{ $t('marketComparation.z') }}</b-col>
                          </b-form-row>
                          <b-form-row class="mb-3">
                            <b-col cols="4">
                              <b-select :options="returnRiskCostOption.x" v-model="returnRiskCostValue.x" size="sm"></b-select>
                            </b-col>
                            <b-col cols="4">
                              <b-select :options="returnRiskCostOption.y" v-model="returnRiskCostValue.y" size="sm"></b-select>
                            </b-col>
                            <b-col cols="4">
                              <b-select :options="returnRiskCostOption.z" v-model="returnRiskCostValue.z" size="sm"></b-select>
                            </b-col>
                          </b-form-row>
                          <template v-if="!isInvestmentCertificates">
                            <b-form-row>
                              <b-col cols="4" class="font-weight-bold">{{ $t('search.label.ifMop') }}</b-col>
                            </b-form-row>
                            <b-form-row class="mb-3">
                              <b-col cols="4">
                                <b-select
                                  :options="returnRiskCostLabels.ifMopShowOptions"
                                  v-model="whenMopVisualize"
                                  size="sm"
                                ></b-select>
                              </b-col>
                            </b-form-row>
                          </template>
                          <return-risk-cost
                            v-if="!isSearching && isReturnRiskCostChartResultsFound"
                            v-model="chartsData.returnRiskCost"
                            :indicators-value="returnRiskCostValue"
                            :when-mop-visualize="whenMopVisualize"
                            :title="$t('common.returnRiskCost')"
                          />
                          <no-content
                            v-else-if="!isSearching && chartsLoaded.returnRiskCost"
                            :icon-name="'exclamation-circle'"
                            :icon-class="['mb-3', 'fa-3x']"
                            :text="$t('common.noChartDataFound')"
                          ></no-content>
                        </b-container>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          {{ $t('common.riyVsRhp') }}
                          <custom-tooltip
                            :css-class="['pointer']"
                            :section="'riyVsRhp'"
                            :tooltipText="isInvestmentCertificates ? $t('search.tips.chartRIYvsRHPInvestmentCertificates') : $t('search.tips.chartRIYvsRHP')"
                            :variant="'black'"
                          ></custom-tooltip>
                        </template>
                        <riy-vs-rhp-chart
                          v-if="!isSearching && isRiyVsRhpChartResultsFound"
                          v-model="chartsData.riyVsRhp"
                          :title="$t('common.riyVsRhp')"
                          :is-investment-certificates="isInvestmentCertificates"
                        />
                        <no-content
                          v-else-if="!isSearching && chartsLoaded.riyVsRhp"
                          :icon-name="'exclamation-circle'"
                          :icon-class="['mb-3', 'fa-3x']"
                          :text="$t('common.noChartDataFound')"
                        ></no-content>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          {{ $t('common.riyAtRhp') }}
                          <custom-tooltip
                            :css-class="['pointer']"
                            :section="'riyAtRhp'"
                            :tooltipText="$t('search.tips.chartRIYatRHP')"
                            :variant="'black'"
                          ></custom-tooltip>
                        </template>
                        <riy-at-rhp-chart
                          v-if="!isSearching && isRiyAtRhpChartResultsFound"
                          v-model="chartsData.riyAtRhp"
                          :title="$t('common.riyAtRhp')"
                        />
                        <no-content
                          v-else-if="!isSearching && chartsLoaded.riyAtRhp"
                          :icon-name="'exclamation-circle'"
                          :icon-class="['mb-3', 'fa-3x']"
                          :text="$t('common.noChartDataFound')"
                        ></no-content>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          {{ $t('common.scenariosCostsAnalysis') }}
                          <custom-tooltip
                            :css-class="['pointer']"
                            :section="'scenariosCostsAnalysis'"
                            :tooltipText="
                              isInvestmentCertificates
                                ? $t('search.tips.chartScenariosCostsAnalysisInvestmentCertificates')
                                : $t('search.tips.chartScenariosCostsAnalysis')
                            "
                            :variant="'black'"
                          ></custom-tooltip>
                        </template>
                        <b-container>
                          <b-form-row>
                            <b-col cols="4" class="font-weight-bold">{{ $t('common.performance') }}</b-col>
                            <b-col cols="4" class="font-weight-bold">{{ $t('common.cost') }}</b-col>
                            <b-col cols="4" class="font-weight-bold">{{ $t('common.period') }}</b-col>
                          </b-form-row>
                          <b-form-row class="mb-3">
                            <b-col cols="4">
                              <b-select
                                :options="scenariosCostsAnalysisOptions.scenario"
                                v-model="scenariosCostsAnalysisValue.scenario"
                                size="sm"
                              ></b-select>
                            </b-col>
                            <b-col cols="4">
                              <b-select
                                :options="scenariosCostsAnalysisOptions.cost"
                                v-model="scenariosCostsAnalysisValue.cost"
                                size="sm"
                              ></b-select>
                            </b-col>
                            <b-col cols="4">
                              <b-select
                                :options="scenariosCostsAnalysisOptions.period"
                                v-model="scenariosCostsAnalysisValue.period"
                                size="sm"
                              ></b-select>
                            </b-col>
                          </b-form-row>
                          <b-form-row v-if="!isInvestmentCertificates">
                            <b-col cols="4" class="font-weight-bold">{{ $t('search.label.ifMop') }}</b-col>
                          </b-form-row>
                          <b-form-row class="mb-3">
                            <b-col v-if="!isInvestmentCertificates" cols="4">
                              <b-select
                                :options="returnRiskCostLabels.ifMopShowOptions"
                                v-model="whenMopVisualizeScenariosCostsAnalysis"
                                size="sm"
                              ></b-select>
                            </b-col>
                            <b-col class="text-right">
                              <b-button v-if="canExport" @click="exportChartData" :variant="isExporting ? 'warning' : 'primary'" class="btn-export">
                                {{ $t('common.export') }}
                                <b-spinner v-if="isExporting" class="ml-1 custom-spinner"></b-spinner>
                                <span v-else><i class="fas fa-download ml-1 icon-size"></i></span>
                              </b-button>
                            </b-col>
                          </b-form-row>
                          <scenarios-costs-analysis-chart
                            v-if="!isSearching && isScenariosCostsAnalysChartResultsFound"
                            :key="scenariosCostsKey"
                            :animation="false"
                            v-model="chartsData.scenariosCostsAnalysis"
                            :title="$t('common.scenariosCostsAnalysis')"
                            :when-mop-visualize="whenMopVisualizeScenariosCostsAnalysis"
                            :xAxisTitle="xAxisTitle(scenariosCostsAnalysisValue.cost)"
                            :yAxisTitle="yAxisTitle(scenariosCostsAnalysisValue.scenario)"
                          />
                          <no-content
                            v-else-if="!isSearching && chartsLoaded.scenariosCostsAnalysis"
                            :icon-name="'exclamation-circle'"
                            :icon-class="['mb-3', 'fa-3x']"
                            :text="$t('common.noChartDataFound')"
                          ></no-content>
                        </b-container>
                      </b-tab>
                    </b-tabs>
                  </b-col>
                </b-row>
              </template>

              <template v-if="currentView === 'pigro'">
                <!-- `v-if="isPigroWidgetReady"`: the widget refetches the FKE corpus on mount AND on
                     every `product-ids` change, so mounting it before /search/productsIds has
                     resolved costs a full extra documents:filter + document download round-trip on
                     an unfiltered corpus. -->
                <fke-widget
                  v-if="isPigroWidgetReady"
                  id="fke-widget-new"
                  :jwt="getToken"
                  :product-ids="searchIdsResult.revisionIds.join(',')"
                  :product-counters="productCounters"
                  :locale="$i18n.locale"
                  :api-base-url="getApiBaseUrl"
                  @fke-jwt-expired="onFkeJwtExpired"
                ></fke-widget>
              </template>
            </div>

            <div class="main-card" v-else>
              <template v-if="isSearching">
                <b-row>
                  <b-col>
                    <div class="d-flex text-center loading-container">
                      <div class="w-100">
                        <custom-spinner :message="$t('common.itemsFound')"></custom-spinner>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </template>
              <template v-else>
                <b-row
                  v-if="
                    hasPendingFilters &&
                    ((!isSearchResultsFound && currentView === 'tab') ||
                      (!isChartsResultsFound && currentView === 'chart') ||
                      (!isPigroResultsFound && currentView === 'pigro'))
                  "
                >
                  <b-col>
                    <no-content :icon-name="'exclamation-circle'" :icon-class="['mb-3', 'fa-3x']" :text="$t('common.noItemsFound')"></no-content>
                  </b-col>
                </b-row>
              </template>
            </div>
          </div>
          <!-- /content-main -->
        </div>
        <!-- /content-with-sidebar -->
      </div>
    </b-container>

    <custom-modal
      v-if="riyGrossReturnDistributionModal"
      :id="'riyGrossReturnDetailsNew'"
      v-model="riyGrossReturnDistributionModal"
      @on-click-table-row="onClickTableRow"
    ></custom-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import FiltersPanel from '../components/Search/FiltersPanel'
import ActiveFilters from '../components/Search/ActiveFilters'
import ResultsTable from '../components/Search/ResultsTable'
import GrandSummary from '../components/Search/GrandSummary'
import RiyVsRhpChart from '../components/Search/Charts/RiyVsRhpChart'
import RiyAtRhpChart from '../components/Search/Charts/RiyAtRhpChart'
import RiyGrossReturnChart from '../components/Search/Charts/RiyGrossReturnChart'
import ScenariosCostsAnalysisChart from '../components/Search/Charts/ScenariosCostsAnalysisChart'
import ReturnRiskCost from '../components/Search/Charts/ReturnRiskCost'
import CustomSpinner from '../components/Lib/CustomSpinner'
import CustomModal from '../components/Lib/CustomModal'
import CustomTooltip from '../components/Lib/CustomTooltip'
import NoContent from '../components/Lib/NoContent'
import { refreshToken, getRealm, defaultRealm } from '../plugins/authentication'
import { downloadFile } from '../utils/fileManager'
import { hasExportPermission } from '../utils/exportPermission'
import { sortByKey } from '../utils/generic'
import { assetClassStorageKey } from '../utils/assetClassState'
import validIndicatorCodes from '../mixins/validIndicatorCodes'
import { buildShownFields, availableTabs, tabLabel } from '../utils/searchResultsFieldFormat'

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('search')

const INIT_CHARTS_DATA = () => ({
  returnRiskCost: [],
  riyVsRhp: [],
  riyAtRhp: [],
  riyGrossReturn: {},
  scenariosCostsAnalysis: {},
})

// Search page on the filter-catalog contract. The results-table view (Prodotti)
// runs on ICatalogProductsSearchManager (native FilterCollection engine). The
// Statistiche views (RiyVsRhp/RiyAtRhp/RiyGrossReturnDistribution/RiskReturn/ScenariosCostsAnalysis)
// and both export buttons (chart export + the plain /api/export/products, /api/export/sids buttons,
// `exportData`) call catalog-native BE endpoints (CHARTS_CATALOG_DESIGN.md) — they take
// `productSearchFilters` as `List<FilterEntry>` directly (`this.appliedFilters`, the live
// FilterCollection). See FILTER_CATALOG_DESIGN.md.
export default {
  name: 'search',
  mixins: [validIndicatorCodes],
  components: {
    FiltersPanel,
    ActiveFilters,
    ResultsTable,
    GrandSummary,
    RiyVsRhpChart,
    RiyAtRhpChart,
    RiyGrossReturnChart,
    ScenariosCostsAnalysisChart,
    ReturnRiskCost,
    CustomSpinner,
    CustomModal,
    CustomTooltip,
    NoContent,
  },
  data() {
    return {
      isDownloading: false,
      isExporting: false,
      riyGrossReturnKey: 0,
      scenariosCostsKey: 0,
      loaderColor: 'blue',
      chartTabIndexVal: 0,
      confidenceLevelValue: 1,
      whenMopVisualizeVal: 'med',
      whenMopVisualizeRiyGrossReturnVal: 'med',
      whenMopVisualizeScenariosCostsAnalysisVal: 'med',
      mainRiyGrossReturnChartData: {},
      riyGrossReturnDistributionValue: null,
      fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
      chartsData: INIT_CHARTS_DATA(),
      // Tracks whether each chart tab has completed at least one fetch (set in
      // showChartsForCurrentTab(), the single dispatcher — see its comment). Guards the
      // "insufficient data" disclaimer: without it, the empty INIT_CHARTS_DATA() shape plus
      // isSearching still being false (nothing has been requested yet) made the disclaimer flash
      // on first mount/tab switch, before the fetch had even started.
      chartsLoaded: {
        riyGrossReturn: false,
        returnRiskCost: false,
        riyVsRhp: false,
        riyAtRhp: false,
        scenariosCostsAnalysis: false,
      },
      returnRiskCostValue: { x: 'EntryCosts', z: 'MRM', y: 'StressReturn' },
      scenariosCostsAnalysisValue: { scenario: 0, cost: 0, period: 2 },
      scenariosCostsAnalysisValuesAPI: {
        scenario: { 0: 'SurrenderValue', 1: 'InsuredBenefit' },
        cost: { 0: 'TotalCosts', 1: 'RIY' },
        period: { 0: 1, 1: 2, 2: 3 },
      },
      confidenceLevelOptions: [
        { value: 1, text: '1%' },
        { value: 2, text: '2%' },
        { value: 5, text: '5%' },
        { value: 10, text: '10%' },
        { value: 25, text: '25%' },
      ],
      tokenValue: window.localStorage.getItem('okv-token'),
    }
  },
  computed: {
    ...mapState({
      catalogLoading: (state) => state.catalogLoading,
      searchResult: (state) => state.searchResult,
      paginator: (state) => state.paginator,
      isSearching: (state) => state.isSearching,
      isLoadingMore: (state) => state.isLoadingMore,
      isLoadingProductIds: (state) => state.isLoadingProductIds,
      columns: (state) => state.columns,
      sidebarOpen: (state) => state.sidebarOpen,
      currentView: (state) => state.currentView,
      selectedTableTab: (state) => state.selectedTableTab,
      appliedFilters: (state) => state.appliedFilters,
      searchIdsResult: (state) => state.searchIdsResult,
    }),
    ...mapGetters(['hasPendingFilters', 'countFiltersSelected']),
    canViewSemanticSearch() {
      return this.$store.getters.getPermissions.userPermissions.canViewSemanticSearch
    },
    canExport() {
      return hasExportPermission(this.$store.getters.getPermissions)
    },
    getApiBaseUrl() {
      const { hostname, port } = window.location
      // Local FE dev servers (start-dev/start-test) proxy to their matching local BE port instead of
      // the shared dev environment — the fke-widget's own AJAX calls bypass fetcher.js/scopeUrl, so
      // it needs its base URL resolved here explicitly.
      if (hostname === 'localhost') {
        if (port === '5001') return 'http://localhost:5011'
        if (port === '5002') return 'http://localhost:5012'
        return 'https://openkidvita-dev.fairmat.com'
      }
      // Same rule as fetcher.js: the default realm talks to the build's API endpoint, a company
      // instance (e.g. arcavita-openkidvita.fairmat.com) to its own host.
      return getRealm() === defaultRealm ? process.env.VUE_APP_API_ENDPOINT : window.location.origin
    },
    getToken() {
      return this.tokenValue
    },
    productCounters() {
      return JSON.stringify(this.searchIdsResult ? this.searchIdsResult.count : {})
    },
    returnRiskCostLabels() {
      return {
        ifMopShowOptions: [
          { value: 'med', text: this.$t('search.label.showMedian') },
          { value: 'min', text: this.$t('search.label.showMinimum') },
          { value: 'max', text: this.$t('search.label.showMaximum') },
        ],
        ...this.getMarketComparationIndices,
      }
    },
    returnRiskCostOption() {
      const available = {}
      Object.keys(this.getMarketComparationIndicesForReturnRiskCost).forEach((axis) => {
        available[axis] = this.keepAvailableIndicators(this.getMarketComparationIndicesForReturnRiskCost[axis])
      })
      const options = available
      if (!this.isInvestmentCertificates) {
        return options
      }
      // "Incremento valore evento assicurato" (InsuredEventIncrementRHP) is an IBIPs-only concept
      // (insured event on the y axis) — doesn't apply to IC. Only this chart's y axis is affected;
      // x/z and every other page reusing getMarketComparationIndicesForReturnRiskCost (legacy
      // Search.vue, MarketComparison.vue, ...) are untouched.
      return {
        ...options,
        y: options.y.filter((option) => option.value !== 'InsuredEventIncrementRHP'),
      }
    },
    isInvestmentCertificates() {
      return this.$store.getters.getSelectedAssetClass === 'investment-certificates'
    },
    scenariosCostsAnalysisOptions() {
      const options = this.$t('scenariosCostsAnalysisOptions')
      if (!this.isInvestmentCertificates) {
        return options
      }
      // "Prestazione assicurata" (InsuredBenefit) is an IBIPs-only concept — doesn't apply to IC.
      // Only the Performance dropdown is affected, which is left with a single value, worded as
      // "Valore di rimborso" (redemption, not insurance surrender) instead of "Valore di riscatto".
      return {
        ...options,
        scenario: { 0: options.scenario['0InvestmentCertificates'] },
      }
    },
    chartTabIndex: {
      get() {
        return this.chartTabIndexVal
      },
      set(newValue) {
        this.chartTabIndexVal = newValue
      },
    },
    whenMopVisualize: {
      get() {
        return this.whenMopVisualizeVal
      },
      set(newValue) {
        this.whenMopVisualizeVal = newValue
        this.saveReturnRiskCostIndicesChartDataToStorage()
      },
    },
    confidenceLevel: {
      get() {
        return this.confidenceLevelValue
      },
      set(newValue) {
        this.confidenceLevelValue = newValue
        this.saveRiyGrossReturnChartDataToStorage()
        this.chartsData.riyGrossReturn = this.riyGrossReturnChartData(this.mainRiyGrossReturnChartData)
        this.riyGrossReturnKey += 1
      },
    },
    whenMopVisualizeRiyGrossReturn: {
      get() {
        return this.whenMopVisualizeRiyGrossReturnVal
      },
      set(newValue) {
        this.whenMopVisualizeRiyGrossReturnVal = newValue
        this.saveRiyGrossReturnChartDataToStorage()
        this.chartsData.riyGrossReturn = this.riyGrossReturnChartData(this.mainRiyGrossReturnChartData)
        this.riyGrossReturnKey += 1
      },
    },
    whenMopVisualizeScenariosCostsAnalysis: {
      get() {
        return this.whenMopVisualizeScenariosCostsAnalysisVal
      },
      set(newValue) {
        this.whenMopVisualizeScenariosCostsAnalysisVal = newValue
        this.saveScenariosCostsAnalysisDataToStorage()
      },
    },
    riyGrossReturnDistributionData: {
      get() {
        return this.riyGrossReturnDistributionValue
      },
      set(newValue) {
        this.riyGrossReturnDistributionValue = newValue
      },
    },
    riyGrossReturnDistributionModal() {
      if (
        !this.chartsData.riyGrossReturn ||
        Object.keys(this.chartsData.riyGrossReturn).length === 0 ||
        this.riyGrossReturnDistributionData == null
      ) {
        return null
      }
      const data = this.chartsData.riyGrossReturn[this.riyGrossReturnDistributionData.name]
      const values = data.filter(
        (el) => el.value >= this.riyGrossReturnDistributionData.min && el.value <= this.riyGrossReturnDistributionData.max
      )
      const items = values.map((item) => ({ ...item.meta, value: item.value }))
      return {
        title: this.$t('common.riyGrossReturn'),
        subtitle: '',
        subHeader: { number: items.length || 0, label: this.$t('common.modal.elementsInRange') },
        otherInfo: {
          label1: this.$t('marketComparation.indices.costInd.RIYGrossReturn'),
          label2:
            this.$t('common.modal.rangeFilter') +
            ' ' +
            this.$n(this.riyGrossReturnDistributionData.min, 'percent') +
            ' - ' +
            this.$n(this.riyGrossReturnDistributionData.max, 'percent'),
          label3: '',
        },
        placeholder: this.$t('common.searchBarPlaceholder'),
        items: items,
        fields: [
          { key: 'issuerName', label: this.$t('search.resultTable.issuer'), sortable: true },
          { key: 'name', label: this.$t('common.product'), sortable: true },
          {
            key: 'value',
            sortable: true,
            class: ['text-right'],
            label: this.$t('common.RIYGrossReturn'),
            formatter: (val) => (typeof val === 'number' && !isNaN(val) ? this.$n(val, 'percent') : '-'),
          },
        ],
        labelDisplayClass: ['d-block'],
      }
    },
    dataToAPI() {
      return {
        productSearchFilters: this.appliedFilters,
        x: this.scenariosCostsAnalysisValuesAPI.cost[this.scenariosCostsAnalysisValue.cost],
        y: this.scenariosCostsAnalysisValuesAPI.scenario[this.scenariosCostsAnalysisValue.scenario],
        period: this.scenariosCostsAnalysisValuesAPI.period[this.scenariosCostsAnalysisValue.period],
        minMaxMed:
          this.whenMopVisualizeScenariosCostsAnalysisVal.charAt(0).toUpperCase() +
          this.whenMopVisualizeScenariosCostsAnalysisVal.slice(1),
      }
    },
    // Tabs and columns come from the BE catalog (`this.columns`, already SOP/MOP-
    // resolved) — IBIPs has General/Indicators/Revisions, Investment Certificates
    // additionally has Payout, and neither the tab list nor the tab count is hardcoded here.
    resultTabs() {
      return availableTabs(this.columns)
    },
    // `isFollowed` stays hardcoded — it's a UI action column, not a catalog data field.
    shownFields() {
      const tabKey = this.resultTabs[this.selectedTableTab]
      const tempRet = [{ key: 'isFollowed', label: '', sortable: false }]
      return tempRet.concat(buildShownFields(this, this.columns, tabKey))
    },
    isSearchResultsFound() {
      return Array.isArray(this.searchResult.results) && this.searchResult.results.length > 0
    },
    isPigroResultsFound() {
      return Array.isArray(this.searchIdsResult.revisionIds) && this.searchIdsResult.revisionIds.length > 0
    },
    // The enclosing card only waits for `isSearching` (the results-table search), which resolves
    // independently of /search/productsIds — the widget additionally needs its own ids to be the
    // ones matching the filters currently applied.
    isPigroWidgetReady() {
      return !this.isLoadingProductIds && this.isPigroResultsFound
    },
    isChartsResultsFound() {
      return (
        this.isReturnRiskCostChartResultsFound ||
        this.isRiyVsRhpChartResultsFound ||
        this.isRiyAtRhpChartResultsFound ||
        this.isRiyGrossChartResultsFound ||
        this.isScenariosCostsAnalysChartResultsFound
      )
    },
    isReturnRiskCostChartResultsFound() {
      return (
        this.chartsData.returnRiskCost &&
        Array.isArray(this.chartsData.returnRiskCost) &&
        this.chartsData.returnRiskCost.find((el) => el.chartItems.length > 0) != undefined
      )
    },
    isRiyVsRhpChartResultsFound() {
      return this.chartsData.riyVsRhp && Array.isArray(this.chartsData.riyVsRhp) && this.chartsData.riyVsRhp.length > 0
    },
    isRiyAtRhpChartResultsFound() {
      return this.chartsData.riyAtRhp && Array.isArray(this.chartsData.riyAtRhp) && this.chartsData.riyAtRhp.length > 0
    },
    isRiyGrossChartResultsFound() {
      return this.chartsData.riyGrossReturn && Object.keys(this.chartsData.riyGrossReturn).length > 0
    },
    isScenariosCostsAnalysChartResultsFound() {
      return (
        this.chartsData.scenariosCostsAnalysis &&
        'x' in this.chartsData.scenariosCostsAnalysis &&
        'y' in this.chartsData.scenariosCostsAnalysis &&
        this.chartsData.scenariosCostsAnalysis.x.length > 0 &&
        this.chartsData.scenariosCostsAnalysis.y.length > 0
      )
    },
  },
  created() {
    this.resetState()
    // On a fresh load/F5 landing directly on the "Statistiche" tab (currentView
    // persisted as 'chart'), nothing else triggers the initial chart fetch — the currentView/
    // chartTabIndexVal watchers only fire on CHANGE, and there's no change on mount (both start
    // already at their persisted/default value). So the chart fetch is kicked off explicitly once
    // the filters are applied.
    this.loadFiltersCatalog().then(() => {
      return this.applyFilters().then(() => {
        if (this.currentView === 'chart') this.showChartsForCurrentTab()
      })
    })
    this.loadIssuers()
    // Runs after mounted() has restored the saved selection, which may hold an indicator that is
    // not available for this asset class.
    this.loadValidIndicatorCodes().then(this.ensureAvailableReturnRiskCostIndicators)
    this.$bus.$on('access-token-updated', this.onAccessTokenUpdated)
  },
  beforeDestroy() {
    this.$bus.$off('access-token-updated', this.onAccessTokenUpdated)
  },
  mounted() {
    const returnRiskCostKey = assetClassStorageKey('lastReturnRiskCostData')
    const returnRiskCostData = JSON.parse(localStorage.getItem(returnRiskCostKey))
    if (returnRiskCostData) {
      this.whenMopVisualize = returnRiskCostData.whenMopVisualize
      this.returnRiskCostValue.x = returnRiskCostData.x
      this.returnRiskCostValue.z = returnRiskCostData.z
      this.returnRiskCostValue.y = returnRiskCostData.y
    } else {
      localStorage.removeItem(returnRiskCostKey)
    }

    const riyGrossReturnKey = assetClassStorageKey('lastRiyGrossReturnData')
    const riyGrossReturnData = JSON.parse(localStorage.getItem(riyGrossReturnKey))
    if (riyGrossReturnData) {
      this.whenMopVisualizeRiyGrossReturn = riyGrossReturnData.whenMopVisualizeRiyGrossReturn
      this.confidenceLevel = riyGrossReturnData.confidenceLevel
    } else {
      localStorage.removeItem(riyGrossReturnKey)
    }

    const scenariosCostsAnalysisKey = assetClassStorageKey('lastScenariosCostsAnalysisData')
    const scenariosCostsAnalysisData = JSON.parse(localStorage.getItem(scenariosCostsAnalysisKey))
    if (scenariosCostsAnalysisData) {
      this.whenMopVisualizeScenariosCostsAnalysisVal = scenariosCostsAnalysisData.whenMopVisualizeScenariosCostsAnalysis
      this.scenariosCostsAnalysisValue.cost = scenariosCostsAnalysisData.cost
      this.scenariosCostsAnalysisValue.scenario = scenariosCostsAnalysisData.scenario
      this.scenariosCostsAnalysisValue.period = scenariosCostsAnalysisData.period
    } else {
      localStorage.removeItem(scenariosCostsAnalysisKey)
    }
  },
  watch: {
    'searchResult.sortBy': function () {
      this.search()
    },
    currentView(val) {
      if (val === 'chart') this.showChartsForCurrentTab()
      // No loadProductIds() for 'pigro' here: setCurrentView already dispatches applyFilters, which
      // loads the ids itself. Calling it here too fired /search/productsIds twice per tab switch.
    },
    chartTabIndexVal() {
      this.showChartsForCurrentTab()
    },
    // Bugfix: applying/removing a sidebar filter while already on the "Statistiche" tab updated
    // `appliedFilters` (via the applyFilters store action) but nothing told the charts to refetch —
    // the applyFilters action only dispatches 'search' (the results table) and, for the 'pigro'
    // view, 'loadProductIds'. Charts silently kept showing stale data until something else happened
    // to trigger showChartsForCurrentTab() (switching chart tab, a chart-specific dropdown, or a
    // full reload). This watcher closes that gap by going through the same single dispatcher.
    appliedFilters() {
      if (this.currentView === 'chart') this.showChartsForCurrentTab()
    },
    // Fixed: go through the dispatcher (respects the currently active chart tab), not the
    // specific chart's own fetch — see the comment on showChartsForCurrentTab().
    returnRiskCostValue: {
      handler() {
        if (this.currentView === 'chart') this.showChartsForCurrentTab()
      },
      deep: true,
    },
    scenariosCostsAnalysisValue: {
      handler(newVal) {
        if (this.currentView === 'chart') this.showChartsForCurrentTab()
        if (Object.keys(newVal).length) this.scenariosCostsKey += 1
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      'loadFiltersCatalog',
      'loadIssuers',
      'applyFilters',
      'search',
      'loadMore',
      'changePageIndex',
      'changeSort',
      'resetState',
    ]),
    setSidebarOpen(value) {
      this.$store.commit('search/setSidebarOpen', value)
    },
    setCurrentView(value) {
      this.$store.dispatch('search/setCurrentView', value)
    },
    setSelectedTableTab(value) {
      this.$store.commit('search/setSelectedTableTab', value)
    },
    resultTabLabel(tabKey) {
      return tabLabel(this, tabKey)
    },
    onChangePageIndex(pageIndex) {
      this.changePageIndex(pageIndex)
    },
    onChangePageSize() {
      // Infinite scroll only on this page — page-size changes are a no-op here.
    },
    sortingChanged(ctx) {
      this.changeSort((ctx.sortDesc ? '-' : '') + ctx.sortBy)
    },
    // Every chart fetch (initial load, tab switch, dropdown change) goes through this single
    // dispatcher, so it always fetches exactly the CURRENTLY active chart tab, never a stale/wrong
    // one. The returnRiskCost/scenariosCostsAnalysis dropdown watchers must not call their own
    // chart's fetch directly: restoring their values from localStorage on mount (see `mounted()`)
    // would then fire it regardless of which tab is actually active after a reload
    // (`chartTabIndexVal` always resets to 0, not persisted). It also wraps every fetch with the
    // same `isSearching` flag the product-table search uses, so the "Loading products in
    // progress" spinner (gated on `isSearching` in the template) shows for chart loads too.
    showChartsForCurrentTab() {
      const chartKeys = ['riyGrossReturn', 'returnRiskCost', 'riyVsRhp', 'riyAtRhp', 'scenariosCostsAnalysis']
      const request = [
        this.showRiyGrossReturn,
        this.showReturnRiskCost,
        this.showRiyVsRhp,
        this.showRiyAtRhp,
        this.showScenariosCostsAnalysis,
      ][this.chartTabIndexVal]
      if (!request) return
      this.chartsLoaded[chartKeys[this.chartTabIndexVal]] = true
      this.$store.commit('search/setSearching', true)
      Promise.resolve(request.call(this)).finally(() => {
        this.$store.commit('search/setSearching', false)
      })
    },
    showRiyVsRhp() {
      return this.post('/api/charts/riyvsrhp', { productSearchFilters: this.appliedFilters }).then((resp) => {
        if (resp != null) {
          this.chartsData.riyVsRhp = resp['data'] ? this.formatRiyVsRhpData(resp['data']) : []
        }
      })
    },
    showRiyAtRhp() {
      return this.post('/api/charts/riyatrhp', { productSearchFilters: this.appliedFilters }).then((resp) => {
        if (resp != null) {
          this.chartsData.riyAtRhp = resp['data'] ? this.formatRiyAtRhpData(resp['data']) : []
        }
      })
    },
    showRiyGrossReturn() {
      return this.post('/api/charts/riyGrossReturnDistribution', { productSearchFilters: this.appliedFilters }).then((resp) => {
        this.saveRiyGrossReturnChartDataToStorage()
        if (resp != null) {
          const source = resp['data'] ? this.formatRiyGrossReturnData(resp['data'])[0] : {}
          this.mainRiyGrossReturnChartData = JSON.parse(JSON.stringify(source))
          this.chartsData.riyGrossReturn = this.riyGrossReturnChartData(source) || {}
        }
      })
    },
    // An axis whose current indicator is not available for the asset class takes the first one that is.
    ensureAvailableReturnRiskCostIndicators() {
      ;['x', 'y', 'z'].forEach((axis) => {
        const options = this.returnRiskCostOption[axis]
        if (options && options.length > 0 && !options.some((o) => o.value === this.returnRiskCostValue[axis])) {
          this.returnRiskCostValue[axis] = options[0].value
        }
      })
    },
    showReturnRiskCost() {
      return this.post('/api/charts/riskReturn', {
        productSearchFilters: this.appliedFilters,
        indicators: Object.values(this.returnRiskCostValue),
      }).then((resp) => {
        this.saveReturnRiskCostIndicesChartDataToStorage()
        if (resp != null) {
          this.chartsData.returnRiskCost = this.formatRiskReturnCostData(resp['data'])
        }
      })
    },
    showScenariosCostsAnalysis() {
      return this.post('/api/charts/scenariosCosts', this.dataToAPI).then((resp) => {
        this.saveScenariosCostsAnalysisDataToStorage()
        if (resp != null) {
          this.chartsData.scenariosCostsAnalysis = this.formatScenariosCostsAnalysisData(resp)
        }
      })
    },
    formatScenariosCostsAnalysisData(source) {
      const keys = Object.keys(source).filter((key) => Array.isArray(source[key]))
      keys.map((key) => {
        source[key].map(
          (el) =>
            (el.productKey.issuerName =
              !el.productKey.issuerName && el.productKey.issuerCode === 'PIT'
                ? this.$t('pit.productUnderTesting')
                : el.productKey.issuerName)
        )
      })
      return source
    },
    formatRiskReturnCostData(source) {
      source.map((level) => {
        level.chartItems.map(
          (el) =>
            (el.productKey.issuerName =
              !el.productKey.issuerName && el.productKey.issuerCode === 'PIT'
                ? this.$t('pit.productUnderTesting')
                : el.productKey.issuerName)
        )
      })
      return source
    },
    formatRiyVsRhpData(source) {
      source.map(
        (el) =>
          (el.productKey.issuerName =
            !el.productKey.issuerName && el.productKey.issuerCode === 'PIT'
              ? this.$t('pit.productUnderTesting')
              : el.productKey.issuerName)
      )
      return source
    },
    formatRiyGrossReturnData(source) {
      source.map((level) => {
        level.chartItems.map(
          (el) =>
            (el.productKey.issuerName =
              !el.productKey.issuerName && el.productKey.issuerCode === 'PIT'
                ? this.$t('pit.productUnderTesting')
                : el.productKey.issuerName)
        )
      })
      return source
    },
    formatRiyAtRhpData(source) {
      source.map((el) => (el.issuerName = !el.issuerName ? this.$t('pit.productUnderTesting') : el.issuerName))
      return source
    },
    saveRiyGrossReturnChartDataToStorage() {
      localStorage.setItem(
        assetClassStorageKey('lastRiyGrossReturnData'),
        JSON.stringify({ confidenceLevel: this.confidenceLevel, whenMopVisualizeRiyGrossReturn: this.whenMopVisualizeRiyGrossReturn })
      )
    },
    saveScenariosCostsAnalysisDataToStorage() {
      localStorage.setItem(
        assetClassStorageKey('lastScenariosCostsAnalysisData'),
        JSON.stringify({ ...this.scenariosCostsAnalysisValue, whenMopVisualizeScenariosCostsAnalysis: this.whenMopVisualizeScenariosCostsAnalysis })
      )
    },
    saveReturnRiskCostIndicesChartDataToStorage() {
      localStorage.setItem(
        assetClassStorageKey('lastReturnRiskCostData'),
        JSON.stringify({ ...this.returnRiskCostValue, whenMopVisualize: this.whenMopVisualize })
      )
    },
    riyGrossReturnChartData(source) {
      if ((Array.isArray(source) && source.length === 0) || !source.chartItems) return {}
      const values = source.chartItems.map((item) => ({
        value: item[this.whenMopVisualizeRiyGrossReturn],
        meta: { ...item.productKey },
      }))
      const sortedValuesByRIYGrossReturnValue = sortByKey(values, 'value')
      const percentageOfProductsCalculatedByConfidenceLevel = Math.ceil(
        (this.confidenceLevel / 100) * sortedValuesByRIYGrossReturnValue.length
      )
      const series2 = sortedValuesByRIYGrossReturnValue.slice(-percentageOfProductsCalculatedByConfidenceLevel)
      const series1 = sortedValuesByRIYGrossReturnValue.filter((x) => !series2.includes(x))
      const firtsElementOfSeries2 = series2[0]
      for (let i = 0; i < series1.length; i++) {
        const el = series1[i]
        if (el.value === firtsElementOfSeries2.value) {
          series2.push(el)
          series1.splice(i, 1)
          i--
        }
      }
      return { series1, series2 }
    },
    showRiyGrossReturnDistributionData(params) {
      this.riyGrossReturnDistributionData = params
      this.$nextTick(() => {
        this.$bvModal.show('riyGrossReturnDetailsNew')
      })
    },
    onClickTableRow(value) {
      this.openProductDetails(value)
    },
    exportData(includeSids) {
      if (!this.canExport) return
      this.isDownloading = true
      const endpoint = includeSids ? '/api/export/sids' : '/api/export/products'
      const fileName = includeSids
        ? this.isInvestmentCertificates
          ? 'OpenKid-Export-InvestmentCertificates.xlsx'
          : 'OpenKid-Export-SID.xlsx'
        : 'OpenKid-Export-Products.xlsx'
      downloadFile(
        this,
        'post',
        endpoint,
        { productSearchFilters: this.appliedFilters },
        this.fileType,
        'isDownloading',
        fileName,
        this.$t('search.label.exportResultsEmpty')
      )
    },
    exportChartData() {
      if (!this.canExport) return
      const endpoint = '/api/charts/scenariosCosts/export'
      const fileName = 'Scenarios-Costs-Analysis.xlsx'
      this.isExporting = true
      downloadFile(this, 'post', endpoint, this.dataToAPI, this.fileType, 'isExporting', fileName, 'Generic Error')
    },
    xAxisTitle(value) {
      return this.$t(`common.scenariosCostsAnalysisChartXaxis-${value}`)
    },
    yAxisTitle(value) {
      // "Valore di riscatto" (SurrenderValue) is worded as "Valore di rimborso" for IC, where
      // redemption — not insurance surrender — is the correct term. Only the "0" scenario needs
      // an IC-specific key: "1" (InsuredBenefit) is never selectable for IC, see
      // scenariosCostsAnalysisOptions.
      if (this.isInvestmentCertificates && String(value) === '0') {
        return this.$t('common.scenariosCostsAnalysisChartYaxis-0InvestmentCertificates')
      }
      return this.$t(`common.scenariosCostsAnalysisChartYaxis-${value}`)
    },
    onAccessTokenUpdated(newToken) {
      this.tokenValue = newToken
    },
    onFkeJwtExpired() {
      refreshToken().catch(() => {})
    },
  },
}
</script>

<style scoped>
/* Scoped to this component: these classes must not depend on any global style leaking in from
   another page (same "cascade applies per PROPERTY, not per rule" concern FiltersPanel.vue's own
   scoped styles are written to avoid; see that file's comment). */
.loading-container {
  padding: 4rem 0;
}

.results-container {
  min-height: 150px;
}

.btn-export {
  font-size: 0.8rem;
}

.icon-size {
  font-size: 0.625rem;
}

/* ── Toolbar row ── */
.filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 6px;
  padding-top: 10px;
}

/* Filters trigger button */
.filters-trigger-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  background: white;
  color: #374151;
  font-size: 12.5px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition:
    background 0.14s,
    border-color 0.14s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.filters-trigger-btn:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.filters-trigger-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e05537;
  color: white;
  font-size: 9px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  padding: 0 3px;
  line-height: 1;
  border: 1.5px solid white;
}

.tabs-group {
  display: inline-flex;
  align-items: center;
  background: white;
  border-radius: 7px;
  padding: 3px;
  gap: 1px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.tab-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 11px;
  /* Transparent 1.5px border reserved on every tab so the Documenti tab's gradient active border
     (same width) only changes colour, never the box size — otherwise activating it adds 3px and
     shoves the row down. */
  border: 1.5px solid transparent;
  border-radius: 5px;
  background: transparent;
  color: #6b7280;
  font-size: 12.5px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: all 0.14s;
  white-space: nowrap;
}
.tab-btn:hover {
  background: #f3f4f6;
  color: #374151;
}
.tab-btn.active {
  background: #e5e7eb;
  color: #374151;
  font-weight: 600;
  box-shadow: none;
}

.tab-btn-documenti {
  position: relative;
  overflow: visible;
}
.tab-btn-documenti.active {
  background:
    linear-gradient(white, white) padding-box,
    conic-gradient(from var(--ai-angle), #a78bfa 0%, #f472b6 22%, #fb923c 44%, #34d399 66%, #60a5fa 88%, #a78bfa 100%)
      border-box;
  border: 1.5px solid transparent;
  color: #1e293b;
  font-weight: 600;
  animation: ai-glow-spin 5s linear infinite;
  transition: none;
}

/* ── Sidebar + results ── */
.content-with-sidebar {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.content-main {
  flex: 1;
  min-width: 0;
}

/* `<transition name="fsb-slide">` above wraps the filters-panel toggle. Vue 2 transition-class
   syntax (`.fsb-slide-enter`/`.fsb-slide-leave-to`, not the Vue 3 `-from` suffix), matching this
   app's Vue version. */
.fsb-slide-enter-active,
.fsb-slide-leave-active {
  transition:
    opacity 0.18s ease,
    transform 0.18s ease;
}
.fsb-slide-enter,
.fsb-slide-leave-to {
  opacity: 0;
  transform: translateX(-8px);
}
</style>

<style>
/* @property/@keyframes are inherently global in CSS (scoped compilation leaves at-rules
   untouched) — kept unscoped on purpose, same as the legacy page's own copy. Needed by
   .tab-btn-documenti.active above. */
@property --ai-angle {
  syntax: '<angle>';
  inherits: false;
  initial-value: 0deg;
}
@keyframes ai-glow-spin {
  to {
    --ai-angle: 360deg;
  }
}
</style>
